<template>
	<div class="contain-layout mx-auto">
		<slot />
	</div>
</template>
